module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/25-f107bba23cee5456f94a62916bbf76d5.png";